import { render, staticRenderFns } from "./cabin.vue?vue&type=template&id=61ada888"
import script from "./cabin.vue?vue&type=script&lang=js"
export * from "./cabin.vue?vue&type=script&lang=js"
import style0 from "./cabin.vue?vue&type=style&index=0&id=61ada888&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports